import React, { useEffect, useState } from 'react';
import apiClient from '../../service/interceptor';
import './dashboard.css'; // Import the CSS file
import { Loader } from '../../components';
import { STRINGS } from '../../comman/constants';

const today = new Date();

export default function Dashboard() {
    const [dashboardData, setDashboardData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [startDate, setStartDate] = useState("2025-05-25");
    const [endDate, setEndDate] = useState(new Date().toISOString().split("T")[0]);
    const [jointType, setJointType] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [dataDate, setDataDate] = useState(new Date().toISOString().split("T")[0]);
    const [activeTab, setActiveTab] = useState('total');


    const totalUsersTable = [
        { title: STRINGS.dashboard.totalUsers, value: "date", showPercentage: false },
        { title: STRINGS.dashboard.totalPatients, value: "totalPatientsCount", showPercentage: false },
        { title: STRINGS.dashboard.reportedPain, value: "usersReportedPainCount", showPercentage: false },
        { title: STRINGS.dashboard.avgPainReported, value: "avgPainReported", showPercentage: true },
        { title: STRINGS.dashboard.peopleImproved, value: "improvedUsersCount", showPercentage: false },
        { title: STRINGS.dashboard.avgPainImproved, value: "avgPainReportedImprovedUsers", showPercentage: true },
        { title: STRINGS.dashboard.latestPain, value: "improvedUsersFromLastFeedbackCount", showPercentage: false },
        { title: STRINGS.dashboard.totalUsersImproved, value: "totalUsersImproved", showPercentage: false },
        { title: STRINGS.dashboard.totalImprovementPercentage, value: "totalImprovementPercentage", showPercentage: true },
    ];

    const userWhoCompletedOnboarding = [
        { title: STRINGS.dashboard.title, value: "date", showPercentage: false },
        { title: STRINGS.dashboard.totalPatients, value: "onboardingCompletedUsersCount", showPercentage: false },
        { title: STRINGS.dashboard.avgPainOnboarded, value: "avgPainReportedOnboardedUsers", showPercentage: false },
        { title: STRINGS.dashboard.reportedPainOnboarded, value: "usersOnboardedReportedPainCount", showPercentage: false },
        { title: STRINGS.dashboard.avgPainOnboardedMultiple, value: "avgPainReportedOnboardedMultipleFeedbackUsers", showPercentage: true },
        { title: STRINGS.dashboard.peopleImprovedOnboarded, value: "improvedOnboardedUsersCount", showPercentage: false },
        { title: STRINGS.dashboard.avgPainImprovedOnboarded, value: "avgPainReportedOnboardedImprovedUsers", showPercentage: true },
        { title: STRINGS.dashboard.latestPainOnboarded, value: "improvedOnboardedUsersFromLastFeedbackCount", showPercentage: false },
        { title: STRINGS.dashboard.totalUsersImprovedOnboarded, value: "totalUsersOnboardedImproved", showPercentage: false },
        { title: STRINGS.dashboard.improvedOnboardedPercentage, value: "improvedOnboardedPercentage", showPercentage: true },
    ];

    const userWhoPerformedAtleastOneExercise = [
        { title: STRINGS.dashboard.title, value: "date", showPercentage: false },
        { title: STRINGS.dashboard.totalPatientsExercise, value: "exerciseCompletedUsersCount", showPercentage: false },
        { title: STRINGS.dashboard.avgPainExercise, value: "avgPainReportedExerciseCompletedUsers", showPercentage: false },
        { title: STRINGS.dashboard.reportedPainExercise, value: "usersExerciseCompletedReportedPainCount", showPercentage: false },
        { title: STRINGS.dashboard.avgPainExerciseMultiple, value: "avgPainReportedExerciseCompletedMultipleFeedbackUsers", showPercentage: true },
        { title: STRINGS.dashboard.peopleImprovedExercise, value: "improvedExerciseCompletedUsersCount", showPercentage: false },
        { title: STRINGS.dashboard.avgPainImprovedExercise, value: "avgPainReportedExerciseCompletedImprovedUsers", showPercentage: true },
        { title: STRINGS.dashboard.latestPainExercise, value: "improvedExerciseCompletedUsersFromLastFeedbackCount", showPercentage: false },
        { title: STRINGS.dashboard.totalUsersImprovedExercise, value: "totalUsersExerciseCompletedImproved", showPercentage: false },
        { title: STRINGS.dashboard.improvedExercisePercentage, value: "improvedExerciseCompletedPercentage", showPercentage: true },
    ];

    const averagePainrReductionTable = [
        { title: STRINGS.dashboard.initialPain, value: "initialPainAvg", showPercentage: false },
        { title: STRINGS.dashboard.painReductionAvg, value: "painReductionAvg", showPercentage: false },
        { title: STRINGS.dashboard.painReducedPercentage, value: "painReducedPercentage", showPercentage: true },
    ];

    const OnbiardingCompletedAveragePainrReductionTable = [
        { title: STRINGS.dashboard.initialPain, value: "initialPainAvgOnboardedUsers", showPercentage: false },
        { title: STRINGS.dashboard.painReductionAvg, value: "painReductionAvgOnboardedUsers", showPercentage: false },
        { title: STRINGS.dashboard.painReducedPercentage, value: "painReducedPercentageOnboardedUsers", showPercentage: true },
    ];

    const exerciseCompletedAveragePainrReductionTable = [
        { title: STRINGS.dashboard.initialPain, value: "initialPainAvgExerciseCompletedUsers", showPercentage: false },
        { title: STRINGS.dashboard.painReductionAvg, value: "painReductionAvgExerciseCompletedUsers", showPercentage: false },
        { title: STRINGS.dashboard.painReducedPercentage, value: "painReducedPercentageExerciseCompletedUsers", showPercentage: true },
    ];

    const tabData = {
        total: {
            label: STRINGS.dashboard.totalUsersTab,
            data: totalUsersTable,
            averageTableData: averagePainrReductionTable,
        },
        onboarding: {
            label: STRINGS.dashboard.onboardingCompletedTab,
            data: userWhoCompletedOnboarding,
            averageTableData: OnbiardingCompletedAveragePainrReductionTable,
        },
        exercised: {
            label: STRINGS.dashboard.performedAtLeastOneExerciseTab,
            data: userWhoPerformedAtleastOneExercise,
            averageTableData: exerciseCompletedAveragePainrReductionTable,
        },
    };



    const checkDate = () => {
        if (new Date(startDate) > new Date(endDate)) {
            setErrorMessage(STRINGS.dashboard.startDateError);
            return false;
        } else {
            setErrorMessage("");
            return true;
        }
    };

    const fetchApiData = async () => {
        console.log(process.env.REACT_APP_BASE_URL, "checking base irl");
        if (checkDate()) {
            setIsLoading(true);
            let currentDate = new Date(endDate);

            const totalCalls = 4;
            const results = [];

            const formatDate = (date) => date.toISOString().split('T')[0];

            for (let i = 0; i <= totalCalls; i++) {
                const endDate = formatDate(currentDate);

                try {
                    const response = await apiClient.post(`/v2/users/users/myflexa-userData-dashboard`, {
                        jointType: jointType,
                        fromDate: startDate,
                        toDate: endDate,
                        dataDate: dataDate
                    });

                    const data = response.data.data;
                    const dataWithDate = {
                        ...data,
                        date: `${startDate} to ${endDate}`
                    };
                    results.push(dataWithDate);
                } catch (error) {
                    console.error(`Error fetching data for range ${startDate} to ${endDate}:`, error);
                }

                currentDate = new Date(currentDate.setDate(currentDate.getDate() - 7));
            }

            setDashboardData(results);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchApiData();
    }, []);

    const card = (data) => {
        return (
            <div className="card-container">
                <div className="card-header">
                    <div className="card-title">
                        {data.title}
                    </div>
                </div>
                <div className="card-content">
                    {dashboardData.length > 0 && dashboardData.map((item, index) => (
                        <div key={index} className="card-item">
                            <div className={`card-item-text ${data.value === "date" ? "small-text" : "default-text"}`}>
                                {item[data.value]} {data.showPercentage ? "%" : ""}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        isLoading ? (<Loader />) : (
            <div className="dashboard">
                <div className="filters">
                    <div className="filter-item">
                        <label htmlFor="jointType">{STRINGS.dashboard.selectJointType}</label>
                        <select
                            value={jointType}
                            onChange={(e) => setJointType(e.target.value)}
                            className="select-box"
                        >
                            <option value="">{STRINGS.dashboard.all}</option>
                            <option value="1">{STRINGS.dashboard.back}</option>
                            <option value="2">{STRINGS.dashboard.neck}</option>
                            <option value="3">{STRINGS.dashboard.knee}</option>

                        </select>
                    </div>
                    <div className="filter-item">
                        <label htmlFor="startDate">{STRINGS.dashboard.startDate}</label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => { setStartDate(e.target.value); setErrorMessage(""); }}
                            className="date-input"
                        />
                    </div>
                    <div className="filter-item">
                        <label htmlFor="endDate">{STRINGS.dashboard.endDate}</label>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => { setEndDate(e.target.value); setErrorMessage(""); }}
                            className="date-input"
                        />
                    </div>
                    <div className="filter-item">
                        <label htmlFor="endDate">Data till date</label>
                        <input
                            type="date"
                            value={dataDate}
                            onChange={(e) => { setDataDate(e.target.value); setErrorMessage(""); }}
                            className="date-input"
                        />
                    </div>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    <button onClick={fetchApiData} className="search-button">Search</button>
                </div>
                <div className="table-scrollable">
                    {/* === Tabs Navigation === */}
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div className="tab-navigation">
                            {Object.keys(tabData).map((key) => (
                                <button
                                    key={key}
                                    className={`tab-button ${activeTab === key ? 'active' : ''}`}
                                    onClick={() => {
                                        setActiveTab(key);
                                    }}                            >
                                    {tabData[key].label}
                                </button>
                            ))}

                        </div>
                        <div>
                            <button
                                className={`tab-button active`}
                                onClick={() => {
                                    fetchApiData();
                                }}                            >
                                Refresh
                            </button>
                        </div>
                    </div>

                    {/* === Active Tab Content === */}
                    <div className="card-list">
                        {tabData[activeTab].data.map((item) => card(item))}
                    </div>

                    {/* === Common Average Pain Reduction Table === */}
                    <h2>Average Pain Reduction</h2>

                    <div className="card-list">
                        {tabData[activeTab].averageTableData.map((item) => card(item))}
                    </div>

                </div>
                <div style={{ marginTop: "80px" }}></div>

            </div>
        )
    );
}
